// extracted by mini-css-extract-plugin
export default {"wrapper":"Q6Jo0p","wrapper-link":"XcI4XA"};